/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Keep_EditingInputs */

const en_dialog_text_to_audio_keep_editing = /** @type {(inputs: Dialog_Text_To_Audio_Keep_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep editing`)
};

const es_dialog_text_to_audio_keep_editing = /** @type {(inputs: Dialog_Text_To_Audio_Keep_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir editando`)
};

/**
* | output |
* | --- |
* | "Keep editing" |
*
* @param {Dialog_Text_To_Audio_Keep_EditingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_keep_editing = /** @type {((inputs?: Dialog_Text_To_Audio_Keep_EditingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Keep_EditingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_keep_editing(inputs)
	return en_dialog_text_to_audio_keep_editing(inputs)
});